import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDoctorFemaleStethoscope = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.58917 17.9492C6.34404 18.8219 5.34609 20.0021 4.6925 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.4858 21.375C19.7777 19.8797 18.6597 18.616 17.2619 17.7309C15.864 16.8458 14.2436 16.3756 12.5891 16.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5891 6.375C12.5891 6.375 11.3941 9.375 8.39661 9.49583C8.20185 10.1488 8.16232 10.8383 8.28117 11.5093C8.40002 12.1803 8.67397 12.8143 9.08117 13.3606C9.48838 13.907 10.0176 14.3507 10.6266 14.6564C11.2357 14.9621 11.9077 15.1213 12.5891 15.1213C13.2705 15.1213 13.9426 14.9621 14.5516 14.6564C15.1606 14.3507 15.6898 13.907 16.097 13.3606C16.5043 12.8143 16.7782 12.1803 16.8971 11.5093C17.0159 10.8383 16.9764 10.1488 16.7816 9.49583C13.7833 9.3725 12.5891 6.375 12.5891 6.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.21411 12.625C3.21411 12.7892 3.24644 12.9517 3.30926 13.1034C3.37208 13.255 3.46415 13.3928 3.58023 13.5089C3.6963 13.625 3.8341 13.717 3.98576 13.7798C4.13741 13.8427 4.29996 13.875 4.46411 13.875C4.62826 13.875 4.79081 13.8427 4.94247 13.7798C5.09412 13.717 5.23192 13.625 5.34799 13.5089C5.46407 13.3928 5.55614 13.255 5.61896 13.1034C5.68178 12.9517 5.71411 12.7892 5.71411 12.625C5.71411 12.4608 5.68178 12.2983 5.61896 12.1466C5.55614 11.995 5.46407 11.8572 5.34799 11.7411C5.23192 11.625 5.09412 11.533 4.94247 11.4702C4.79081 11.4073 4.62826 11.375 4.46411 11.375C4.29996 11.375 4.13741 11.4073 3.98576 11.4702C3.8341 11.533 3.6963 11.625 3.58023 11.7411C3.46415 11.8572 3.37208 11.995 3.30926 12.1466C3.24644 12.2983 3.21411 12.4608 3.21411 12.625V12.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7141 16.375C15.7141 17.2038 15.3849 17.9987 14.7988 18.5847C14.2128 19.1708 13.4179 19.5 12.5891 19.5C11.7603 19.5 10.9655 19.1708 10.3794 18.5847C9.79335 17.9987 9.46411 17.2038 9.46411 16.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.71411 12.7033C6.25093 12.8419 6.72644 13.1551 7.06586 13.5934C7.40528 14.0318 7.58934 14.5706 7.58911 15.125V19.5C7.58911 19.9973 7.78666 20.4742 8.13829 20.8258C8.48992 21.1775 8.96683 21.375 9.46411 21.375H10.7141C11.2113 21.3748 11.6881 21.1772 12.0397 20.8256C12.3913 20.474 12.5889 19.9972 12.5891 19.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.71411 9.5C5.71411 7.67664 6.43844 5.92795 7.72775 4.63864C9.01707 3.34933 10.7657 2.625 12.5891 2.625C14.4125 2.625 16.1612 3.34933 17.4505 4.63864C18.7398 5.92795 19.4641 7.67664 19.4641 9.5V11.23C19.4642 11.7377 19.5674 12.2401 19.7674 12.7067L20.9166 15.3825C21.0463 15.6837 21.0524 16.0239 20.9336 16.3296C20.8148 16.6353 20.5807 16.882 20.2816 17.0167C19.3772 17.4097 18.4282 17.6912 17.4558 17.855"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgDoctorFemaleStethoscope.displayName = 'SvgDoctorFemaleStethoscope';
export default SvgDoctorFemaleStethoscope;
